var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "expert-view-section mb-4",
    attrs: {
      "elevation": "0"
    }
  }, [_vm.title ? _c('v-card-title', [_c('v-row', [_c('v-col', {
    staticClass: "title-text",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _c('v-col', {
    staticClass: "title-space py-0 d-flex align-center"
  }, [_vm._t("title-actions")], 2)], 1)], 1) : _vm._e(), _c('v-card-text', [_vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }